import React, { useState } from 'react';
import { Grid, Collapse } from '@mui/material';
import {
    Select,
    WeightInput,
    InformationAlert
} from '../../Common';
import Enums from '../../../enums';
import { getContainerSpacing } from '../utils';

const VerificationTests = ({
    formState,
    setGlobalState,
    dropdownOptions,
    requiredFieldsMissing,
}) => {
    const isRetroFit = formState.workItemTypeId === Enums.SE.WorkItemType.Retrofit;
    const isInstall = formState.workItemTypeId === Enums.SE.WorkItemType.Install;
    const isReinstall = formState.workItemTypeId === Enums.SE.WorkItemType.Reinstall;
    const renderWarning = (
        isRetroFit
        || isInstall
        || isReinstall
    );
    const contentPositioning = isInstall || isReinstall ? 'left' : 'center';
    const [warning, setWarning] = useState(renderWarning);

    const determineInfoMessage = () => {
        if (isRetroFit) {
            return "When completed, this will create a shutdown and install work item, and this record will no longer be editable.";
        }
        return "When completed, this will create reinstall work item for this system.";
    };

    return (
        <Grid container spacing={getContainerSpacing()} justifyContent={contentPositioning}>
            {(isInstall || isReinstall) ? (
                <WeightInput
                    required
                    showConversionArrows
                    header="Current Gas Weight"
                    variant="standard"
                    value={formState.currentGasWeightLbs}
                    onChange={new_weight => setGlobalState("currentGasWeightLbs", new_weight)}
                    columnSpan={4}
                    lbsError={requiredFieldsMissing.currentGasWeightLbs}
                />
            ) : (
                <Grid item xs={12} md={6}>
                    <Select
                        required
                        label="Verification Method"
                        value={formState.verificationLeakDetectionMethodId}
                        onChange={e => setGlobalState("verificationLeakDetectionMethodId", e.target.value)}
                        options={dropdownOptions.leakDetectionMethods}
                        error={requiredFieldsMissing.verificationLeakDetectionMethodId}
                    />
                </Grid>
            )}
            <Grid item xs={12} md={6}>
                <Select
                    required
                    label="Charge Amount Determined By"
                    value={formState.chargeCapacitySourceTypeId}
                    onChange={e => setGlobalState("chargeCapacitySourceTypeId", e.target.value)}
                    options={dropdownOptions.chargeCapacitySourceTypes}
                    error={requiredFieldsMissing.chargeCapacitySourceTypeId}
                />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Collapse in={warning}>
                    <Grid item xs={12} md={12} lg={12}>
                        <InformationAlert
                            title="Information"
                            message={determineInfoMessage()}
                            onClose={() => setWarning(false)}
                        />
                    </Grid>
                </Collapse>
            </Grid>
        </Grid>
    );
};

export default VerificationTests;
